import gql from "graphql-tag"
import type { TypedDocumentNode } from "@graphql-typed-document-node/core"

type OrderOperationEvent = {
  orderId: string
  type: string
}

type OnOrderOperationDeletedSubscription = { OnOrderOperationDeleted: OrderOperationEvent }

const ON_ORDER_OPERATION_DELETED: TypedDocumentNode<
  OnOrderOperationDeletedSubscription,
  Record<string, never>
> = gql`
  subscription OnOrderOperationDeleted {
    OnOrderOperationDeleted {
      orderId
      type
    }
  }
`

export default ON_ORDER_OPERATION_DELETED
